import { headerStyles } from "@guestsupply/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import Print from "@guestsupply/XDL/Icons/Print";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { css } from "styled-components";

headerStyles.headerGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        .links-wrapper {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
    `,
};

headerStyles.printLink = {
    ...createLinkIconStyles(Print, {
        icon: {
            iconProps: {
                size: 16,
            },
            position: "left",
        },
    }),
};
headerStyles.addToListLink = {
    ...createLinkIconStyles(Plus, {
        icon: {
            iconProps: {
                size: 20,
                css: css`
                    margin-right: 5px;
                `,
            },
            position: "left",
        },
    }),
};

headerStyles.continueButton = {
    css: css`
        width: 100%;
    `,
};
